var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElettricisti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    id: "svg4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    style: {
      fill: "none",
      stroke: "#09253e",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 39.731075,30.943266 a 4.2330528,4.2330528 0 0 1 -0.03584,0.547195 4.2330528,4.2330528 0 0 1 -0.107527,0.540029 4.2330528,4.2330528 0 0 1 -0.114696,0.344088 4.2330528,4.2330528 0 0 1 -0.301078,0.67145 4.2330528,4.2330528 0 0 1 -0.303467,0.456394 4.2330528,4.2330528 0 0 1 -0.360815,0.415774 4.2330528,4.2330528 0 0 1 -0.408605,0.365594 4.2330528,4.2330528 0 0 1 -0.0024,0 4.2330528,4.2330528 0 0 1 -1.462376,0.735968 4.2330528,4.2330528 0 0 1 -0.0024,0 4.2330528,4.2330528 0 0 1 -1.084833,0.155317 H 18.736883 16.43818 A 4.2330528,4.2330528 0 0 1 12.705776,32.94089 v -1.823191 l 0.965381,-0.709682 V 27.55734 l 2.912804,-1.416977 v -6.411037 h -4.379959 v -7.847128 a 4.2330528,4.2330528 0 0 1 4.234199,-4.2342 h 2.2987 16.810155 a 4.2330528,4.2330528 0 0 1 2.960594,1.256879 4.2330528,4.2330528 0 0 1 0.360815,0.415774 4.2330528,4.2330528 0 0 1 0.303467,0.456394 4.2330528,4.2330528 0 0 1 0,0.0024 4.2330528,4.2330528 0 0 1 0.241339,0.492236 4.2330528,4.2330528 0 0 1 0,0.0024 4.2330528,4.2330528 0 0 1 0.05974,0.174414 4.2330528,4.2330528 0 0 1 0.114696,0.344089 4.2330528,4.2330528 0 0 1 0.107528,0.540028 4.2330528,4.2330528 0 0 1 0.03584,0.547196 v 0.0024 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#09253e",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 26.313741,14.006468 a 7.4139597,7.4139597 0 0 1 7.07054,7.40507 7.4139597,7.4139597 0 0 1 -7.412238,7.414629 7.4139597,7.4139597 0 1 1 0.341698,-14.819699 z",
    id: "path7"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#09253e",
    strokeMiterlimit: 10,
    x1: 25.970898,
    y1: 14.132063,
    x2: 25.970898,
    y2: 16.774662,
    id: "line1",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#09253e",
    strokeMiterlimit: 10,
    x1: 25.970898,
    y1: 26.439735,
    x2: 25.970898,
    y2: 29.08235,
    id: "line2",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#09253e",
    stroke: "#09253e",
    cx: 23.316067,
    cy: 21.411448,
    r: 1.0643804,
    id: "circle2",
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#09253e",
    stroke: "#09253e",
    cx: 28.613501,
    cy: 21.411448,
    r: 1.0643804,
    id: "circle3",
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "rotate(-90,8.0605929,-0.03634143)"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#09253e",
    strokeMiterlimit: 10,
    x1: -5.9255719,
    y1: 5.9544177,
    x2: -11.832989,
    y2: 5.9544177,
    id: "line9",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#09253e",
    strokeMiterlimit: 10,
    x1: -5.9255719,
    y1: -1.4833915,
    x2: -11.832989,
    y2: -1.4833915,
    id: "line10",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#09253e",
    strokeMiterlimit: 10,
    strokeWidth: "1px",
    d: "m -30.746356,2.2171791 h -2.045996 c -2.251117,0.129275 -3.973132,2.055779 -3.85005,4.307243 v 0",
    id: "path10",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#09253e",
    stroke: "#09253e",
    points: "17.44,23.74 18.6,26.12 20.93,26.12 21.51,26.91 27.92,26.91 27.92,30.88 21.51,30.88 20.93,31.67 18.6,31.67 17.44,34.05 12.2,34.05 12.2,23.74 ",
    id: "polygon10",
    style: {
      fill: "none",
      strokeWidth: 0.831158,
      strokeDasharray: "none"
    },
    transform: "matrix(-1.2031405,0,0,1.2031405,2.8453248,-32.529237)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElettricisti);
export default __webpack_public_path__ + "static/media/elettricisti.6c50fb634cffefd23840f9319f1f2120.svg";
export { ForwardRef as ReactComponent };